export async function fetchData(
  endpoint: string,
  getToken: () => Promise<string | undefined>,
  queryString?: string,
  pagination?: {
    page: number;
    pageSize: number;
  }
) {
  try {
    const accessToken = await getToken();

    const response = await fetch(
      `${endpoint}?${queryString ? `${queryString}&` : ""}${
        pagination
          ? `page=${pagination.page}&pageSize=${pagination.pageSize}`
          : ""
      }`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(`API request failed: ${error.message}`);
    } else {
      throw new Error(`API request failed with an unknown error`);
    }
  }
}
